import { render, staticRenderFns } from "./CommissionsRanking.vue?vue&type=template&id=dd1ed34e"
import script from "./CommissionsRanking.vue?vue&type=script&lang=js"
export * from "./CommissionsRanking.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports